export const THEMES = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
  NATURE: 'NATURE'
};


export const ORGANIZATION_USERS          = "Organization and Users"
export const MANAGE_ONDATA_CLIENTS       = "Manage OnData Clients"
export const CLOUD_MANAGEMENT            = "Cloud Management"
export const MANAGE_DATA_CLASSIFICATIONS = "Manage Data Classifications"
export const MANAGE_DATA_ACCESS_ROLES    = "Manage Data Access Roles"
export const MANAGE_DATA_OWNER_GROUPS    = "Manage Data Owner Groups"
export const KEY_MANAGEMENT              = "Key Management"
export const MANAGE_DATA_ACCESS_TOKENS   = "Manage Data Access Tokens"
export const MANAGE_OBFUSCATION_RULES    = "Manage Obfuscation Rules"
export const MANAGE_BACKUP_JOBS          = "Manage Backup Jobs"
export const MANAGE_DATA_CATALOG         = "Manage Data Catalog"
export const EDIT_DATA_CLASSIFICATION_ENCRYPTION = "Edit Data Classification and Encryption"
export const EDIT_DATA_OWNERSHIP         = "Edit Data Ownership"
export const SCHEDULE_ENCRYPTION_OBFUSCATION = "Schedule Encryption and Obfuscation"
export const MANAGE_DATABASE_DEPLOYMENTS = "Manage Database Deployments"
export const MANAGE_DATABASE_OPERATIONS  = "Manage Database Operations"
export const SECUREFILE_ONLY             = "SecureFile Only"

export type Permissions_new =
| typeof ORGANIZATION_USERS
| typeof MANAGE_ONDATA_CLIENTS
| typeof CLOUD_MANAGEMENT
| typeof MANAGE_DATA_CLASSIFICATIONS
| typeof MANAGE_DATA_ACCESS_ROLES
| typeof MANAGE_DATA_OWNER_GROUPS
| typeof KEY_MANAGEMENT
| typeof MANAGE_DATA_ACCESS_TOKENS
| typeof MANAGE_OBFUSCATION_RULES
| typeof MANAGE_BACKUP_JOBS
| typeof MANAGE_DATA_CATALOG
| typeof EDIT_DATA_CLASSIFICATION_ENCRYPTION
| typeof EDIT_DATA_OWNERSHIP
| typeof SCHEDULE_ENCRYPTION_OBFUSCATION
| typeof MANAGE_DATABASE_DEPLOYMENTS
| typeof MANAGE_DATABASE_OPERATIONS
| typeof SECUREFILE_ONLY


